import { addClass, removeClass, select } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

const selectors = {
  CART_FAQ_SELECTOR: '.js-cart-faq',
  HIDDEN_CLASS: '!hidden'
}

class CartFaq extends HTMLElement {
  constructor() {
    super()

    this.cartFaqEl = select(selectors.CART_FAQ_SELECTOR, this)
    this.attachEvent()
  }

  attachEvent() {
    globalEmitter.on(emitterProps.cart.update, (value) => {
      if (value?.length > 0) removeClass(selectors.HIDDEN_CLASS, this.cartFaqEl)
      else addClass(selectors.HIDDEN_CLASS, this.cartFaqEl)
    })
  }
}

if (!customElements.get('cart-faq')) {
  customElements.define('cart-faq', CartFaq)
}
